export default __webpack_public_path__ + "static/media/phone.d5369e97.jpg";